import { v4 } from 'uuid';

export interface DeviceState {
  type: string;
  ident: string;
}

const initialState: DeviceState = {
  type: 'web',
  ident: `web-${v4()}`,
};

export default initialState;
